import type { IGroup } from '../types/types'

/**
 * Merge a mark-free / partial group payload into a cached group without wiping
 * nested `settings` / `branding` when the API returns a lean object.
 */
export function mergeGroupDetail(cached: IGroup, updated: Partial<IGroup>): IGroup {
  const hasSettings = cached.settings != null || updated.settings != null
  const hasBranding = cached.branding != null || updated.branding != null
  const hasMembership = cached.settings?.membership != null || updated.settings?.membership != null

  return {
    ...cached,
    ...updated,
    ...(hasSettings
      ? {
          settings: {
            ...cached.settings,
            ...updated.settings,
            ...(hasMembership
              ? {
                  membership: {
                    ...cached.settings?.membership,
                    ...updated.settings?.membership,
                  },
                }
              : {}),
          },
        }
      : {}),
    ...(hasBranding
      ? {
          branding: {
            ...cached.branding,
            ...updated.branding,
          },
        }
      : {}),
  }
}
